<template>
  <div class="welcome" :style="{ padding: !isDesktop && '20px 25px 0px 25px' }">
    <div class="user" :title="name">Welcome! {{ name }}</div>
    <div
      class="account"
      :style="{
        'flex-direction': !isDesktop && 'column',
        'align-items': !isDesktop && 'start',
        'line-height': !isDesktop && '28px',
      }"
    >
      Account Balance >>
      <span>Date update review: {{ balanceUpdateTime || '-' }}</span>
    </div>
    <div class="balance">
      {{ balance || 0 }} $
      <span>
        <a-button class="withdraw" @click="modalVisible = true">
          Withdrawal
        </a-button>
      </span>
    </div>
    <div class="bonus" :style="{ 'font-size': !isDesktop && '12px' }">
      <div class="bonus-item bonus-left">
        Pending Earnings
        <span
          :style="{
            'margin-left': !isDesktop && '0px',
            'line-height': !isDesktop && '25px',
          }"
          >{{ pendingBonus || 0 }} $</span
        >
      </div>
      <div class="bonus-item bonus-right">
        Fraud Cases
        <span
          :style="{
            'margin-left': !isDesktop && '0px',
            'line-height': !isDesktop && '25px',
          }"
          >{{ fraudsBonus || 0 }} $</span
        >
      </div>
    </div>
    <a-modal
      :visible="modalVisible"
      title="Withdraw"
      okText="Confirm"
      @ok="handleWithdraw"
      @cancel="handleCloseModal"
    >
      <p>Withdrawal Amount:</p>
      <p class="modal-balance">{{ balance }} $</p>
      <p>Receiving Information:</p>
      <p>{{ withdrawAccount }}</p>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Welcome',
  computed: {
    ...mapState({
      name: (state) => state.user.name,
      balanceUpdateTime: (state) => state.user.balanceUpdateTime,
      balance: (state) => state.user.balance,
      pendingBonus: (state) => state.user.pendingBonus,
      fraudsBonus: (state) => state.user.fraudsBonus,
      withdrawAccount: (state) => state.user.withdrawAccount,
    }),
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  data() {
    return {
      modalVisible: false,
    }
  },
  methods: {
    handleWithdraw() {
      this.$store.dispatch('user/Withdrawl', { businessType: 3 }).then(() => {
        this.$message.success('Withdraw Successfully!')
        this.modalVisible = false
        this.$store.dispatch('user/afterLogin')
      })
    },
    handleCloseModal() {
      this.modalVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.welcome {
  // width: 660px;
  // height: 260px;
  background-image: linear-gradient(to left, #00b4ff, #007dff);
  color: #fff;
  text-align: left;
  padding: 25px;
  font-weight: normal;
  border-radius: 4px;

  .user {
    font-size: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .account {
    width: 100%;
    height: 40px;
    font-size: 20px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    span {
      font-size: 12px;
    }
  }

  .balance {
    height: 84px;
    font-size: 32px;
    display: flex;
    line-height: 84px;
    border-bottom: 1px solid #d8d8d8;

    span {
      margin-left: 50px;
      font-size: 14px;

      .withdraw {
        border: none;
      }
    }
  }

  .bonus {
    height: 65px;
    padding: 20px 0;
    font-size: 18px;
    display: flex;

    .bonus-item {
      width: 49%;
      height: 25px;

      span {
        margin-left: 50px;
      }
    }

    .bonus-left {
      border-right: 1px solid #fff;
    }
    .bonus-right {
      padding-left: 20px;
    }
  }
}

.modal-balance {
  font-size: 20px;
  font-weight: bold;
}

@media screen and (min-width: 320px) and (max-width: 374px) {
  .welcome .bonus .bonus-right {
    padding-left: 10px;
  }
}
</style>
